import budgetManagementSystem from './slice.budgetManagement'
import cartItems from './slice.cart'
import checkoutRates from './slice.checkoutRates'
import checkoutSessionToken from './slice.checkoutSessionToken'
import checkoutTax from './slice.checkoutTax'
import integrations from './slice.integrations'
import portalPages from './slice.portalPages'
import storeViews from './slice.storeViews'

export default {
  budgetManagementSystem,
  cartItems,
  checkoutRates,
  checkoutSessionToken,
  checkoutTax,
  integrations,
  portalPages,
  storeViews
}
